import {
  userData,
  updateUserData,
  moneyTransfer,
} from "../../js/api/profile.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";

let allCurrencies = [];
let UserProfile = {
  render: async () => {
    allCurrencies = [];
    let request = Utils.parseRequestURL();
    const user = await userData(request.id);
    let role = localStorage.getItem("role");

    if (user.total_coins.includes('|')) {
      var allCoins = user.total_coins.split('|');

      for (let index = 0; index < allCoins.length; index++) {
        const coin = allCoins[index];
        const currency = coin.split(';')[0].split('.')[1];
        allCurrencies.push({
          currency,
          id: coin.split(';')[0].split('.')[0],
          value: coin.split(';')[1]
        });
      }

    } else {
      if (user.currency) {
        allCurrencies.push({
          currency: user.currency,
          id: user.currency_id,
          value: user.total_coins
        });
      } else {
        const currency = user.total_coins.split(';')[0].split('.')[1];
        const value = user.total_coins.split(';')[1];
        const id = user.total_coins.split(';')[0].split('.')[0];

        allCurrencies.push({
          currency: currency,
          id: id,
          value: value
        });
      }

    }

    let useCoinsViewProfile = ``;

    allCurrencies.forEach(currency => {
      useCoinsViewProfile += `<option value="${currency.id}">${currency.currency}</option>`;
    });

    let view = /*html*/ `
            <div class="addFundModal">
                <a class="closeModalBtn">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
                    <g>
                    \t<g>
                    \t\t<path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717    L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859    c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287    l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285    L284.286,256.002z"/>
                    \t</g>
                    </g>
                </svg>
                </a>
                <div class="addFundHolder">
                    <span>${_t('Users Add Funds')}</span>
                    <div>
                    <select name="currency" id="currency" style="
    float: left;
    width: 35%;
    height: 40px;
    background: transparent;
    color: white;
">
                      ${useCoinsViewProfile}
                    </select>
                    <input type="text" placeholder="20.00" style=" width: 50%;float:right;" id="transferValue">
</div>
                    <a class="addFundsBtn" id="addFundsBtn">${_t('+ Add Funds')}</a>
                </div>
            </div>
            
            <div class="withdrawFundModal">
                <a class="closeModalBtn">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
                    <g>
                    \t<g>
                    \t\t<path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717    L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859    c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287    l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285    L284.286,256.002z"/>
                    \t</g>
                    </g>
                </svg>
                </a>
                <div class="withdrawFundHolder">
                    <span>${_t('Users Withdraw Funds')}</span>
                    <div>
                    <select name="currencyWithdraw" id="currencyWithdraw" style="
                    float: left;
                    width: 35%;
                    height: 40px;
                    background: transparent;
                    color: white;
                ">
                                      ${useCoinsViewProfile}
                                    </select>
                    <input type="text" placeholder="20.00" style=" width: 50%;float:right;" id="withdrawValue">
                    </div>
                    <a class="withdrawFundsBtn" id="withdrawFundsBtn">${_t('Withdraw Funds')}</a>
                </div>
            </div>
            
            <div class="createUsersHeader m-t-6">
                 <a class="backBtn">
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                 </a>
                 <span>User Profile - ${user.name} ${user.surname}</span>
           </div>
           <div class="createUsersWrapper m-t-6">
                <div class="createUsersHolder m-t-6">
                    <p>The details must be change carefully!</p>
                    <input type="hidden" id="userId" placeholder="${_t('User ID')}" vaLue="${user.id}">
<!--                    <span class="errorMsg">Error Old Password</span>-->
                    <input type="text" placeholder="${_t('Username')}" value="${user.username}" disabled>
<!--                    <span class="errorMsg">Error Old Password</span>-->
                    <input type="text" placeholder="${_t('First Name')}" id="name" value="${user.name}" >
<!--                    <span class="errorMsg">No Error</span>-->
                    <input type="text" placeholder="${_t('Surname')}" id="surname" value="${user.surname}">
                    
                    <input type="password" placeholder="${_t('New password')}" id="password">
<!--                    <span class="errorMsg">No Error</span>-->
                    <input type="text" disabled placeholder="${_t('Bilanci')}" id="profileBalance" class="fundsInput" value="">
                    <a class="addFundsModalBtn">+</a>
                    <a class="withdrawFundsModalBtn">-</a>
<!--                    <span class="errorMsg">No Error</span>-->

                    ${role == 'Supermanager' ? `    <input type="number" value="${user.single_percentage ? user.single_percentage : "0"}" placeholder="% - 1" id="txtSinglePercentage">
                      <input type="number" placeholder="% - 2" value="${user.double_percentage ? user.double_percentage : "0"}" id="txtDoublePercentage">
                      <input type="number" placeholder="% - 3" value="${user.triple_percentage ? user.triple_percentage : "0"}" id="txtTriplePercentage">` : ""
      }
      <div>
      <label style="width:120px;color:white;float:left;padding-top:10px;">${_t('Casino lejuar')}</label>
      <select name="casinoEnabled" id="casinoEnabled" style="
    float: left;
    width: 35%;
    height: 40px;
    background: transparent;
    color: white;
">
<option value="0" ${user.casinoEnabled == 0 ? 'selected' : ''}>Jo</option>
<option value="1" ${user.casinoEnabled == 1 ? 'selected' : ''}>Po</option>
                    </select>
     </div>
      <a class="updateCreateUserBtn" id="updateUserBtn">${_t('Submit')}</a>
                    </div>
            </div>
       `;
    return view;
  },
  after_render: async () => {
    const submitBtn = document.getElementById("updateUserBtn");
    const addFundsBtn = document.getElementById("addFundsBtn");
    const withdrawFundsBtn = document.getElementById("withdrawFundsBtn");

    submitBtn.addEventListener("click", async () => {
      const user = document.getElementById("userId").value;
      const name = document.getElementById("name").value;
      const surname = document.getElementById("surname").value;
      const password = document.getElementById("password").value;
      const casinoEnabled = document.getElementById("casinoEnabled").value;
      const singlePercentage = document.getElementById("txtSinglePercentage") ? document.getElementById("txtSinglePercentage").value : "0";
      const doublePercentage = document.getElementById("txtDoublePercentage") ? document.getElementById("txtDoublePercentage").value : "0";
      const triplePercentage = document.getElementById("txtTriplePercentage") ? document.getElementById("txtTriplePercentage").value : "0";

      var res = await updateUserData({
        user,
        name,
        surname,
        password,
        single_percentage: singlePercentage,
        double_percentage: doublePercentage,
        triple_percentage: triplePercentage,
        casino_enabled: casinoEnabled,
        partner_type: singlePercentage != "0" || doublePercentage != "0" || triplePercentage != "0" ? "turnover_percentage" : "no_percentage"
      });
      if (res && res.error) {
        alert(res.error);
      }
      if (res && res.message) {
        alert(res.message);
      }
    });

    addFundsBtn.addEventListener("click", async () => {
      const user = document.getElementById("userId").value;
      const amount = document.getElementById("transferValue").value;
      const currency = $('#currency').val();
      var res = await moneyTransfer({
        user,
        amount,
        currency
      });
      if (res && res.error) {
        alert(res.error);
      }
      if (res && res.message) {
        alert(res.message);
      }

      if (res && res.success == "OK") {
        window.location.href = "#/users";
      }
    });

    withdrawFundsBtn.addEventListener("click", async () => {
      const user = document.getElementById("userId").value;
      const preAmount = document.getElementById("withdrawValue").value;
      const currency = $('#currencyWithdraw').val();

      const amount = -1 * Number.parseFloat(preAmount);
      var res = await moneyTransfer({
        user,
        amount,
        currency
      });
      if (res && res.error) {
        alert(res.error);
      }
      if (res && res.message) {
        alert(res.message);
      }

      if (res && res.success == "OK") {
        $(".withdrawFundModal").removeClass("clicked");
        $(".addFundModal").removeClass("clicked");
      }

      if (res && res.success == "OK") {
        window.location.href = "#/users";
      }
    });
    $('body').on('change', '#currency', async function (e) {
      e.preventDefault()
      e.stopPropagation();
      e.stopImmediatePropagation();
      const selectedCurrency = allCurrencies.find(a => a.id == $('#currency').val());
      if (selectedCurrency) {
        $('#profileBalance').val(selectedCurrency.value);
      }
    });

    const selectedCurrency = allCurrencies.find(a => a.id == $('#currency').val());
    if (selectedCurrency) {
      $('#profileBalance').val(selectedCurrency.value);
    }
  },
};

export default UserProfile;
